import { BASE_URL } from "@/utils";
import { AxiosRequestConfig } from "axios";
import getToken from "@/utils/getToken";
import getAxiosObj from "@/utils/request";
import { IGCCListings } from "@/types/IGCCListings";

export const getGCCListings = async (
  publicAddress: string,
  pageNumber: number,
  searchString : string = ""
) => {
  let url = `${BASE_URL}/pro/GetGccListings?publicAddress=${publicAddress}&pagenumber=${pageNumber}&search=${searchString}`;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    maxBodyLength: Infinity,
    method: "GET",
    url,
  };

  const axiosObj = getAxiosObj();

  const response = await axiosObj<IGCCListings[]>(config);
  return response.data;
};
